const genders = ['F', 'M'];
export default genders;
